import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import styles from "./styles/Dashboard.module.scss";

import { Col, Row } from "react-bootstrap";
import { SubTitle } from "../../Components/CustomComponents";
import {
  FaWandMagicSparkles,
  FaUserTie,
  FaCalendarCheck,
  FaClipboardList,
} from "react-icons/fa6";
import { RiParentFill } from "react-icons/ri";
import DashboardCard from "../../Components/Cards/DashboardCard";
import { fetchDashboard } from "../../redux/slices/dashboardSlice";

const bg1 = "#700404";
const bg2 = "#CC0000";
const iconColor = "#F75DBE";

export default function Dashboard() {
  const dispatch = useDispatch();
  const { data, loading } = useSelector((s) => s.dashboard);

  useEffect(() => {
    dispatch(fetchDashboard());
  }, [dispatch]);

  const users = data?.users ?? {};
  const appointments = data?.appointments ?? {};
  const agents = data?.agents ?? {};
  const quotes = data?.quotes ?? {};

  const cardData = [
    {
      icon: <FaWandMagicSparkles color={iconColor} />,
      number: loading ? "…" : (users.total_artists ?? 0),
      text: "Numbers of Artist",
    },
    {
      icon: <RiParentFill color={iconColor} />,
      number: loading ? "…" : (users.total_users ?? users.total ?? 0),
      text: "Numbers of Users",
    },
    {
      icon: <FaUserTie color={iconColor} />,
      number: loading ? "…" : (agents.total ?? 0),
      text: "Numbers of Agents",
    },
    {
      icon: <FaCalendarCheck color={iconColor} />,
      number: loading ? "…" : (appointments.total ?? 0),
      text: "Numbers of Appointments",
    },
    {
      icon: <FaClipboardList color={iconColor} />,
      number: loading ? "…" : (quotes.total ?? 0),
      text: "Numbers of Quotes",
    },
  ];

  return (
    <div className={styles.Dashboard}>
      <div className={styles.headerContainer}>
        <div className={styles.titleContainer}>
          <SubTitle text={"Dashboard"} />
        </div>
      </div>
      <Row className={`${styles.matchRow} w-100 mt-2 mb-5`}>
        {cardData.map((card, index) => (
          <Col key={index} className="mt-2 mb-2" lg={4} md={4} sm={6}>
            <DashboardCard
              bg1={bg1}
              bg2={bg2}
              icon={card.icon}
              number={card.number}
              text={card.text}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
}
